import { EntityType, CompendaStatus, Errors, CompendaEventDetail } from './constants'

export default (entity: EntityType, id: number): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
        let pending: boolean

        const eventHandler = (event: Event) => {
            const detail = (event as CustomEvent<CompendaEventDetail>).detail

            // only resolve the actual window and not when it opens
            if (detail.bron !== entity || detail.bronid !== id) { return }

            switch (detail.status) {
                case CompendaStatus.Opened:
                    pending = false
                    break
                case CompendaStatus.NotFound:
                    document.removeEventListener('compenda', eventHandler)
                    reject(Errors.EntityNotFound)
                    break
                case CompendaStatus.Closed:
                    document.removeEventListener('compenda', eventHandler)
                    resolve()
                    break
            }
        }

        document.addEventListener('compenda', eventHandler)

        openEntityTroughIframe(entity, id)
        pending = true

        setTimeout(() => {
            if (pending) {
                reject(Errors.CompendaNotResponding)
            }
        }, 500)
    })
}

const openEntityTroughIframe = (entity: EntityType, id: number): void => {
    const url = 'http://compenda/' + entity + '/' + String(id)

    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.id = 'iframe-'+entity+'-'+id
    iframe.onload = () => { iframe.parentNode!.removeChild(iframe) }
    document.body.appendChild(iframe)
}
